/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
const observedAttributes = {
    LABEL_POSITION: 'label-position',
    LABEL_ALIGNMENT: 'label-alignment',
    INVALID: 'invalid',
    REQUIRED: 'required',
    OPTIONAL: 'optional',
    DISABLED: 'disabled',
    FLOAT_LABEL: 'float-label',
    VARIANT: 'variant',
    THEME: 'theme',
    SHAPE: 'shape',
    DENSITY: 'density',
    DENSE: 'dense',
    POPOVER_ICON: 'popover-icon',
    POPOVER_EXPANDED: 'popover-expanded',
    SUPPORT_TEXT_INSET: 'support-text-inset'
};
const attributes = {
    ...observedAttributes
};
const defaults = {
    DEFAULT_VARIANT: 'outlined',
    DEFAULT_THEME: 'default',
    DEFAULT_SHAPE: 'default',
    DEFAULT_DENSITY: 'default',
    DEFAULT_LABEL_POSITION: 'inset',
    DEFAULT_LABEL_ALIGNMENT: 'default',
    DEFAULT_SUPPORT_TEXT_INSET: 'none'
};
export const BASE_FIELD_CONSTANTS = {
    observedAttributes,
    attributes,
    defaults
};
